export const initialState = {
  member: {
    status: "",
    tier: "",
    fantasyName: "",
    organizationName: "",
    CNPJ: "00000000000000",
    mainActivity: "",
    adminName: "",
    firstName: "",
    lastName: "",
    occupation: "",
    socialReason: "",
    numberOfEmployees: "",
    annualBudgetforTravel: "",
    milesBalance: "",
    address: {
      streetAddress: "",
      streetAddressNumber: "",
      complement: "",
      zipCode: "00000000",
      city: "",
      state: "",
      country: "",
    },
    DocumentType: "",
    DOcumentNumber: "00000000000",
    celPhoneDDINumber1: "55",
    celPhoneDDDNumber1: "00",
    celPhoneNumber1: "000000000",
    homePhoneDDINumber1: "55",
    homePhoneDDDNumber1: "00",
    homePhoneNumber1: "000000000",
    workPhoneDDINumber: "55",
    workPhoneDDDNumber: "00",
    workPhoneNumber: "000000000",
    email: "",
  },
  zendesk: [],
  dropdowns: {
    occupation: { stateName: "occupation", items: [{ id: "", description: "" }] },
    numberOfEmployees: { stateName: "numberOfEmployees", items: [{ id: "", description: "" }] },
    mainActivity: { stateName: "mainActivity", items: [{ id: "", description: "" }] },
    annualBudgetforTravel: { stateName: "annualBudgetforTravel", items: [{ id: "", description: "" }] },
  },
  isLoading: true,
  error: { message: "", isError: false },
};

export type StateType = typeof initialState;

type DocumentType = {
  preferential: boolean;
  type: string;
  number: string;
};
type PhoneType = {
  type: string;
  verified: boolean;
  internationalCode: number | string;
  areaCode: number | string;
  number: string;
};
type ElectronicAddressType = {
  type: string;
  preferential: boolean;
  address: string;
};
export type AddressType = {
  type?: string;
  preferential: boolean;
  streetAddress?: string;
  streetAddressNumber?: string;
  complement?: string;
  zipCode: string;
  city?: string;
  state?: string;
  country?: string;
};
export type MemberT = {
  fantasyName: string;
  organizationName: string;
  mainActivity: string;
  firstName: string;
  lastName: string;
  occupation: string;
  socialReason: string;
  numberOfEmployees: string;
  annualBudgetforTravel: string;
  relationshipWithGOL: string;
  providedServicesToGol: string;
  providedServicesToOthers: string;
  HowMeetedProgram: string;
  addressList: AddressType;
  documentList: DocumentType[];
  phoneList: PhoneType[];
  electronicAddressList: ElectronicAddressType[];
};

export type MemberPost = {
  socialReason: string;
  fantasyName: string;
  firstName: string;
  lastName: string;
  email: string;
  balanceRedeemablePoints: string;
  balanceQualifyingPoints: string;
  customerCategory: string;
  codeReserve: string;
  numberOfEmployees: string;
  mainActivity: string;
  annualBudgetforTravel: string;
  documentNumber: string;
  organizationName: string;
  address: {
    streetAddress: string;
    streetAddressNumber: string;
    city: string;
    state: string;
    complement: string;
    zipCode: string;
    country: string;
  };
  celPhone: {
    DDINumber1: string;
    DDDNumber1: string;
    Number1: string;
  };
  homePhone: {
    DDINumber1: string;
    DDDNumber1: string;
    Number1: string;
  };
};

export type ModalState = {
  socialReason: string;
  fantasyName: string;
  occupation: string;
  DOcumentNumber: string;
  adminName: string;
  email: string;
  balanceRedeemablePoints: string;
  balanceQualifyingPoints: string;
  codeReserve: string;
  numberOfEmployees: string;
  mainActivity: string;
  annualBudgetforTravel: string;
  documentNumber: string;
  organizationName: string;
  streetAddress: string;
  streetAddressNumber: string;
  city: string;
  state: string;
  complement: string;
  zipCode: string;
  country: string;
  celPhoneNumber1: string;
  homePhoneNumber1: string;
};
